// Plan-or-pack paid access, read from payment.getSubscription. Mirrors
// server/entitlements.ts userHasPaidAccess: an active non-free plan, or any
// completed credit-pack purchase (hasPurchasedCredits, which the server only
// computes when the plan alone doesn't grant access). It unlocks 720p/1080p
// renders (clampRenderResolutionForPlan) and private projects.

export type PaidAccessSubscription = {
  plan?: string | null;
  status?: string | null;
  hasPurchasedCredits?: boolean | null;
};

/**
 * Whether this subscription row has paid access. False until it has loaded.
 *
 * Nov 3 2026: the home composers (ComposerV2, Landing) counted plan tier
 * only, so credit-pack buyers on the free plan saw 720p/1080p and Private
 * locked behind an upgrade dialog the server and Studio never applied.
 */
export function subscriptionHasPaidAccess(
  subscription: PaidAccessSubscription | null | undefined,
): boolean {
  if (!subscription) return false;
  if (subscription.hasPurchasedCredits) return true;
  return (
    !!subscription.plan &&
    subscription.plan !== "free" &&
    subscription.status === "active"
  );
}
